import {
  DataTablePrimeReact,
  IColumnProps,
  TableERP,
} from "@finanedi.es/storybook"
import { FlujoTesoreriaReadingFiltersDtoProps } from "api/DTOs/FlujoTesoreriaReadingFiltersDto"
import { RefObject } from "react"
import { useTranslation } from "react-i18next"

interface PagosCobrosTableProps {
  columns: IColumnProps[]
  refTable: RefObject<
    DataTablePrimeReact<FlujoTesoreriaReadingFiltersDtoProps[]>
  >
  items: FlujoTesoreriaReadingFiltersDtoProps[] | undefined
  loading: boolean
  selection: FlujoTesoreriaReadingFiltersDtoProps[]
  onSelectionChange: (e: {
    value: FlujoTesoreriaReadingFiltersDtoProps[]
  }) => void
  onSort: (e: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => void
  sortField: string | undefined
  sortOrder: 1 | 0 | -1 | null | undefined
}
export default ({
  columns,
  refTable,
  items,
  loading,
  selection,
  onSelectionChange,
  onSort,
  sortField,
  sortOrder,
}: PagosCobrosTableProps) => {
  const { t } = useTranslation()

  return (
    <TableERP
      refTable={refTable}
      data-testid='tabla-pagos-cobros'
      id='tabla-pagos-cobros'
      className='!tw-h-full tw-overflow-x-hidden tw-overflow-y-hidden'
      tableClassName='tw-relative'
      dataKey='id'
      columns={columns}
      value={items}
      loading={loading}
      selectionMode='checkbox'
      size='small'
      selectionColumnMode='multiple'
      onSort={onSort}
      sortField={sortField}
      sortOrder={sortOrder}
      removableSort
      selection={selection}
      onSelectionChange={onSelectionChange}
      lazy
      emptyMessage={t("primeReact.table.emptyMessage")}
    />
  )
}
